// extracted by mini-css-extract-plugin
export default {"countryWrapper":"ResultHeader_countryWrapper__M0kUg","pushPinWrapper":"ResultHeader_pushPinWrapper__35lto","defaultPinn":"ResultHeader_defaultPinn__kbW1J"};